// extracted by mini-css-extract-plugin
export default {"container_checkbox_error_log":"ErrorLog_container_checkbox_error_log__nZhvz","subtitle_notifications":"ErrorLog_subtitle_notifications__EWXA8"};